import { gql } from 'graphql.macro'
import RuleFragment from '../../../../lib/RuleFragment'

export default gql`
  mutation DuplicateRule($id: ID!) {
    duplicateRule(id: $id) {
      ...RuleFragment
    }
  }

  ${RuleFragment}
`
